import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=447feeec&scoped=true&"
import script from "./Debug.vue?vue&type=script&lang=js&"
export * from "./Debug.vue?vue&type=script&lang=js&"
import style0 from "./Debug.vue?vue&type=style&index=0&id=447feeec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447feeec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447feeec')) {
      api.createRecord('447feeec', component.options)
    } else {
      api.reload('447feeec', component.options)
    }
    module.hot.accept("./Debug.vue?vue&type=template&id=447feeec&scoped=true&", function () {
      api.rerender('447feeec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/developerTools/Debug.vue"
export default component.exports